import React from 'react'
import { FaCheck } from 'react-icons/fa'
import { format_day } from '../utils/util'
import { useTranslation } from 'react-i18next'

function PollTask({ task }) {
    const { t, locale, i18n } = useTranslation()
    return (
        <div className="studnet-task-item">
            <div className="task-poll-header">
                <p style={{ color: '#35316a', fontSize: 17, fontWeight: 600 }}>{task.content.title}</p>
            </div>
            <div className="task-poll-description">
                <p style={{ color: '#35316a', fontSize: 15, fontWeight: 400 }}>{task?.content?.description ?? task.content.body ?? task.content?.message}</p>
            </div>
            <div className="task-poll-body">
                {task.answers.map((answer, index) => (
                    <div className="task-poll-answer" key={index}>
                        <div className="">
                            <i className="fas fa-check">
                                <FaCheck style={{ margin: 0 }} />
                            </i>
                        </div>
                        <p style={{ color: 'white', fontSize: 16, fontWeight: 600, margin: 0 }}>{answer}</p>
                    </div>
                ))}
            </div>
            <div className="task-poll-footer">
                <p style={{ fontSize: 15, color: '#8f8fa1', fontWeight: 600, textAlign: i18n.language === 'ar' ? 'right' : 'left' }}>{t('poll')}</p>
                <p style={{ marginTop: 5 }}>{format_day(task.created_date, true, i18n.language)}</p>
            </div>
        </div>
    )
}

export default PollTask
